<template>
    <div>
        <div class="form-horizontal">


            <form-input :form="form" property="name"></form-input>
            <form-input :form="form" property="title"></form-input>
            <form-input :form="form" property="slug"></form-input>

            <form-input :form="form" property="sort_order"></form-input>

            <form-input :form="form" property="meta_description">
                <textarea v-model="form.meta_description" class="form-control" cols="10" rows="5"></textarea>
            </form-input>

            <form-input :form="form" property="description_short">
                <textarea v-model="form.description_short" class="form-control" cols="10" rows="5"></textarea>
            </form-input>

            <form-input :form="form" property="description">
                <textarea v-model="form.description" class="form-control" cols="10" rows="5"></textarea>
            </form-input>

            <form-input :form="form" property="body">
                <text-editor v-model="form.body"></text-editor>
            </form-input>

            <form-input :form="form" property="cta.text" label="CTA text"></form-input>
            <form-input :form="form" property="cta.url"  label="CTA url" ></form-input>

            <form-input :form="form" property="image" label="Logo">
                <photo-upload @input="files.image = $event" :value="form.image.url" @clear="files.image = null; form.image = {url: ''}"></photo-upload>
            </form-input>

            <gallery-upload v-model="form.gallery" @change="files.gallery = $event" label="Feature Image"></gallery-upload>

            <form-links :form="form"/>

             <form-input :form="form" property="type">
                <select v-model="form.type" class="form-control">
                    <option v-for="type in types" :value="type">{{type}}</option>
                </select>
            </form-input>

            <form-input :form="form" property="tags" label="Tags" v-if="tagsAll">
                <div class="m-checkbox-inline">
                    <label class="m-checkbox" v-for="tag in tagsAll"> {{ tag.name }}
                        <input type="checkbox" :checked="isSelected(tag)" @change="toggleTag(tag, $event)">
                        <span></span>
                    </label>
                </div>
            </form-input>

            <form-faq :form="form"/>


        </div>
    </div>
</template>


<script>
import Model from 'lib/Model';
import Form from 'lib/Form';
import UploadFiles from 'lib/UploadFiles';
import axios from 'axios';

export default {
    mixins: [Model, UploadFiles],
    data() {
        return {
            method: '/api/integrations/integrations',
            form: new Form(() => {
                return {
                    name: null,
                    title: null,
                    slug: null,
                    meta_description: null,
                    description: null,
                    description_short: null,
                    body: null,
                    sort_order: 999,
                    image: {
                        alt: {}
                    },
                    gallery: [],
                    tags: [],
                    faqs: [],
                    links:[],
                    type: 'native',
                    cta: {
                        text: null,
                        url: null,
                    },
                };
            }),
            tagsAll: null,
            slug: '',
            validSlug: '',

            types: [
                'native',
                'import',
                'zapier',
            ]
        };
    },
    methods: {
        isSelected(tag) {
            if (!this.form) {
                return false;
            }
            return this.form.tags.find(x => x.id == tag.id);
        },
        toggleTag(tag) {
            if (this.isSelected(tag)) {
                this.form.tags = this.form.tags.filter(x => x.id != tag.id);
            } else {
                this.form.tags.push(tag);
            }
        },
        addFaq() {
            this.form.faqs.push({
                question: "",
                answer: "",
            })
        },
    },
    mounted() {
        this.$on('input', () => {
            if (this.$refs.activityLog) {
                this.$refs.activityLog.load();
            }
        });

        axios.get('/api/integrations/tags', {
            //                params: {'q_type': this.form.type },
        }).then(res => {
            this.tagsAll = res.data.data;
        });
    },
};
</script>


// WEBPACK FOOTER //
// resources/js/forms/integrations/Integration.vue